import { Button } from "../../Atoms/Button";
import { Title } from "../../Atoms/Title";
import { FormClientEdit } from "../../Molecules/FormClientEdit";
import * as S from "./styles";
import { useClientDetail } from "./useClientDetail";

export const ClientDetailTemplate = () => {
  const { submitForm, handleResetPassword, shouldShowResetPasswordButton } =
    useClientDetail();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Dados do Cliente</Title>
        {shouldShowResetPasswordButton && (
          <S.WrapperButton>
            <Button onClick={handleResetPassword}>
              <img src="/assets/svgs/icon-replay.svg" alt="icon-reset" />
              Redefinir Senha
            </Button>
          </S.WrapperButton>
        )}
        <FormClientEdit submitForm={submitForm} />
      </S.Wrapper>
    </S.Container>
  );
};
